import { useState, useEffect } from "react";
import styles from "./EditModal.module.css";

function EditModal({ isOpen, plan, onUpdate, onClose }) {
    const [name, setName] = useState("");
    const [version, setVersion] = useState("");
    const [price, setPrice] = useState("");
    const [cycle, setCycle] = useState("");
    const [image, setImage] = useState("");
    const [description, setDescription] = useState("");
    const [points, setPoints] = useState("");
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (plan && isLoading === true) {
            setName(plan.name || "");
            setPrice(plan.price || "");
            setVersion(plan.version || "");
            setCycle(plan.cycle || "mensal");
            setImage(plan.image || "");
            setDescription(plan.description || "");
            setPoints(plan.points || "");
            setIsLoading(false);
        }
    }, [isLoading, plan, isOpen]);

    if (!isOpen) return null;

    const handleSubmit = (event) => {
        event.preventDefault();
        const plano = {
            name,
            version,
            price,
            cycle,
            image,
            description,
            points
        };
        onUpdate(plano);
        onClose();
    };

    return (
        <div className={styles.modal}>
            <div className={styles.modalContent}>
                <h2>Editar Plano</h2>
                <form onSubmit={handleSubmit}>
                    <input name="name" placeholder="Nome do plano" value={name} onChange={(e) => setName(e.target.value)} required />
                    <input name="version" placeholder="Versão" value={version} onChange={(e) => setVersion(e.target.value)} required />
                    <input name="price" placeholder="Preço (€)" type="number" value={price} onChange={(e) => setPrice(e.target.value)} step="0.01" required />
                    <select name="ciclo" value={cycle} onChange={(e) => setCycle(e.target.value)}>
                        <option value="mensal">Mensal</option>
                        <option value="semanal">Semanal</option>
                    </select>
                    <input name="imagem" placeholder="Imagem" value={image} onChange={(e) => setImage(e.target.value)} required />
                    <input name="description" placeholder="Resumo" value={description} onChange={(e) => setDescription(e.target.value)} required />
                    <textarea name="pontos" placeholder="Descrição" value={points} onChange={(e) => setPoints(e.target.value)} required />
                    <div className={styles.buttons}>
                        <button className={styles.cancelButton} type="button" onClick={onClose}>Cancelar</button>
                        <button className={styles.confirmButton} type="submit">Salvar</button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default EditModal;
